import { jwtDecode } from "jwt-decode";
import { getStoredAuthToken, isAuthTokenValid } from "../../utils/authSession";

// Prévia estática no mesmo grupo de clientes de Gestão de Custos. O produto ainda
// não tem um ID de contrato; nenhum contrato ou permissão real é criado aqui.
const PREVIEW_CLIENTS = new Set([2, 87]);
const MANAGER_ROLES = new Set([
  "gestor",
  "admin",
  "administrador",
  "aipim",
  "setup",
]);
export function getEquipmentIdentity() {
  try {
    const raw = getStoredAuthToken();
    if (!isAuthTokenValid(raw)) return null;
    const claims = jwtDecode(raw.replace(/^Bearer /, ""));
    const clientId =
      claims.id_clienteAipim ??
      claims.id_clienteaipim ??
      claims.idClienteAipim ??
      claims.id_cliente ??
      claims.idCliente ??
      claims.cliente_id;
    if (typeof clientId !== "number" && typeof clientId !== "string") return null;
    return {
      name: claims.nome || claims.name || "Usuário",
      role: String(claims.role || "").toLowerCase(),
      clientId: Number(clientId),
    };
  } catch {
    return null;
  }
}
export function canManageEquipment(role) {
  return MANAGER_ROLES.has(role);
}
export function canAccessGestaoEquipamentos() {
  const identity = getEquipmentIdentity();
  return Boolean(
    identity &&
      PREVIEW_CLIENTS.has(identity.clientId) &&
      (canManageEquipment(identity.role) ||
        ["usuario", "user"].includes(identity.role)),
  );
}
